import { render, staticRenderFns } from "./PreShare.vue?vue&type=template&id=49b18090&"
import script from "./PreShare.vue?vue&type=script&lang=js&"
export * from "./PreShare.vue?vue&type=script&lang=js&"
import style0 from "./PreShare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports